/****************************
* VimeoVideo handler object *
****************************/

// external dependancy
import Player from '@vimeo/player';


function VimeoVideo () {

  /**
	 * Creates hero background video from Vimeo link if provided
	 *
	 * @since   1.0.0
	 * @access  public
	 */
  const createHeroVideo = () => {
    const container = document.querySelector('.hero__vimeo-video');
    if(container) {
      const url = container.getAttribute('data-url');
      const options = {
        url,
        background: true,
        loop: true
      }
      const video = new Player(container, options);
    }
    return;
  }
  
  /**
	 * Creates popup video
	 *
	 * @since   1.0.0
	 * @access  public
	 */
  function createPopupVideo() {
    const popup = document.querySelector('#popup-video');
    const videoContainer = document.querySelector('#popup-video__container'); 
    const closeButton = document.querySelector('#close-button');
    const links = document.querySelectorAll('.js-popup');
    let video;

    /**
     * Creates Vimeo player
     *
     * @since   1.0.0
     * @access  public
     */
    function createPlayer(element, container) {
      // setup regex that checks if provided url starts with 'http:', 'https:' or 'www'
      const expression = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
      const regex = new RegExp(expression);
      // get url and set it as a options parameter
      const url = element.getAttribute('data-link');
      const options = {
        url
      }
      // check if url is provided and if so check if it matches regex
      if(url && url.match(regex)) {
        // create new Player object
        video = new Player(container, options);
        // show popup
        popup.classList.remove('js-hide-popup');
      } else {
        console.warn('Video URL not provided or invalid');
      }
    }
    
    links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        createPlayer(link, videoContainer);
      });
    });

    closeButton.addEventListener('click', () => {
      popup.classList.add('js-hide-popup');
      video.destroy();
    });
    
  }
  
  function init() {
    createHeroVideo();
    createPopupVideo();
  }
  
  return {
    init
  };

}

export default VimeoVideo;
